module.exports = "<a href=https://twitter.com/share class=twitter-share-button data-count=none> Tweet </a>";


//////////////////
// WEBPACK FOOTER
// ./src/apps/observatoire/ng/social/obsSocialTwitterButton.html
// module id = 3582
// module chunks = 12